export default __webpack_public_path__ + "static/media/information--go-straight--g1.2b4c9d90.png";